import { createTheme } from '@mui/material/styles';

const getTheme = (mode = 'light') =>
  createTheme({
    palette: {
      mode,
      primary: {
        main: '#F05513',
      },
    },
    typography: {
      fontFamily: 'Josefin Sans, Arial, sans-serif',
    },
  });

export default getTheme; 
